import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Share2, Edit2, ExternalLink, X, Copy, Check, Twitter, Facebook, Linkedin, Mail, MapPin } from 'lucide-react';
export function DashboardHome() {
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const profileUrl = 'eaves.pro/marcuschen';
  const fullUrl = `https://${profileUrl}`;
  const handleCopy = () => {
    navigator.clipboard.writeText(fullUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="p-8 max-w-4xl mx-auto" data-id="element-523">
      <h1 className="text-3xl font-serif font-semibold text-brand-dark mb-8" data-id="element-524">
        My Profile
      </h1>

      {/* Profile Preview Card */}
      <div className="bg-white rounded-2xl border border-brand-light shadow-sm overflow-hidden mb-8" data-id="element-525">
        <div className="p-6 bg-brand-light/30 flex flex-col items-center justify-center min-h-[300px]" data-id="element-526">
          {/* Mini Profile Preview */}
          <div className="w-full max-w-sm bg-white rounded-2xl shadow-premium overflow-hidden border border-brand-light" data-id="element-527">
            <div className="h-24 bg-gradient-to-r from-brand-sage via-brand-sandstoneBg to-brand-light relative" data-id="element-528">
              <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-forest to-transparent" data-id="element-529"></div>
            </div>
            <div className="px-6 pb-6 -mt-12 relative z-10 flex flex-col items-center text-center" data-id="element-530">
              <div className="w-20 h-20 rounded-full border-4 border-white overflow-hidden shadow-sm mb-3 bg-white" data-id="element-531">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Marcus Chen" className="w-full h-full object-cover" data-id="element-532" />
              </div>
              <h3 className="text-lg font-serif font-semibold text-brand-dark mb-1" data-id="element-533">
                Marcus Chen
              </h3>
              <p className="text-xs text-brand-muted font-serif italic mb-3" data-id="element-534">
                Senior real estate advisor
              </p>

              <div className="flex flex-col items-center gap-2 w-full" data-id="element-535">
                <div className="flex gap-2" data-id="element-536">
                  <span className="text-[10px] font-medium bg-brand-offwhite border border-brand-light px-2 py-0.5 rounded-full text-brand-dark" data-id="element-537">
                    Zillow 4.9 ★
                  </span>
                  <span className="text-[10px] font-medium bg-brand-offwhite border border-brand-light px-2 py-0.5 rounded-full text-brand-dark" data-id="element-538">
                    Google 4.8 ★
                  </span>
                </div>
                <p className="text-[10px] text-brand-muted font-mono mt-1" data-id="element-539">
                  94109 · 94123 · 94117
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-brand-light" data-id="element-540">
          <div data-id="element-541">
            <h2 className="text-lg font-medium text-brand-dark" data-id="element-542">Marcus Chen</h2>
            <a href="/marcuschen" target="_blank" rel="noreferrer" className="text-sm text-brand-muted font-mono hover:text-brand-forest transition-colors" data-id="element-543">
              {profileUrl}
            </a>
          </div>
          <div className="flex items-center gap-3" data-id="element-544">
            <a href="/marcuschen" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-brand-forest hover:bg-brand-forestHover text-white rounded-xl text-sm font-medium transition-colors shadow-sm" data-id="element-545">
              Preview
              <ExternalLink size={16} data-id="element-546" />
            </a>
            <button onClick={() => setShowShareModal(true)} className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-brand-light hover:border-brand-forest/30 rounded-xl text-sm font-medium text-brand-dark transition-colors shadow-sm" data-id="element-547">
              <Share2 size={16} className="text-brand-muted" data-id="element-548" />
              Share
            </button>
            <Link to="/admin/edit" className="inline-flex items-center gap-2 px-4 py-2 bg-brand-offwhite border border-brand-light hover:bg-brand-sage rounded-xl text-sm font-medium text-brand-dark transition-colors" data-id="element-549">
              <Edit2 size={16} className="text-brand-muted" data-id="element-550" />
              Edit
            </Link>
          </div>
        </div>
      </div>

      {/* Make it yours Section */}
      <div className="bg-white rounded-2xl border border-brand-light shadow-sm p-6" data-id="element-551">
        <h2 className="text-xl font-serif font-medium text-brand-dark" data-id="element-552">
          Make it yours
        </h2>
        <p className="text-sm text-brand-muted mt-2 mb-6 max-w-2xl" data-id="element-553">
          The fundamentals are already set — your performance, reviews, and
          verification. These are the touches that are yours to add.
        </p>

        <div className="space-y-5" data-id="element-554">
          <div className="border-t border-brand-light pt-5 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-555">
            <div data-id="element-556">
              <h3 className="text-sm font-medium text-brand-dark" data-id="element-557">Photo</h3>
              <p className="text-sm text-brand-muted mt-1 max-w-md" data-id="element-558">
                A real headshot builds trust. We'll use your initials in a
                branded placeholder until you upload one.
              </p>
            </div>
            <button className="shrink-0 bg-brand-forest text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-brand-forestHover transition-colors" data-id="element-559">
              Upload photo
            </button>
          </div>

          <div className="border-t border-brand-light pt-5 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-560">
            <div data-id="element-561">
              <h3 className="text-sm font-medium text-brand-dark" data-id="element-562">Bio</h3>
              <p className="text-sm text-brand-muted mt-1 max-w-md" data-id="element-563">
                We've drafted a bio from your transaction history. Edit it, or
                write your own.
              </p>
            </div>
            <div className="shrink-0 flex gap-2" data-id="element-564">
              <button className="border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-565">
                View AI draft
              </button>
              <button className="border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-566">
                Write your own
              </button>
            </div>
          </div>

          <div className="border-t border-brand-light pt-5 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-567">
            <div data-id="element-568">
              <h3 className="text-sm font-medium text-brand-dark" data-id="element-569">
                Listings & Videos
              </h3>
              <p className="text-sm text-brand-muted mt-1 max-w-md" data-id="element-570">
                Showcase your listings and video portfolio. Choose from
                carousel, small card, or large card layouts. Paste a URL and
                we'll fetch the details automatically.
              </p>
            </div>
            <button className="shrink-0 border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-571">
              Add listings & videos
            </button>
          </div>

          <div className="border-t border-brand-light pt-5 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-572">
            <div data-id="element-573">
              <h3 className="text-sm font-medium text-brand-dark" data-id="element-574">
                Custom Links
              </h3>
              <p className="text-sm text-brand-muted mt-1 max-w-md" data-id="element-575">
                Add any links you want — intake forms, booking pages, resources,
                or anything else. Paste a URL and we'll fetch the details, or
                customize manually.
              </p>
            </div>
            <div className="shrink-0 flex gap-2" data-id="element-576">
              <button className="border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-577">
                Add custom link
              </button>
              <button className="border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-578">
                Use Eaves contact form
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Market Status Section */}
      <div className="bg-brand-sage/30 rounded-2xl border border-brand-sage p-6 mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-579">
        <div className="flex items-center gap-4" data-id="element-580">
          <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0" data-id="element-581">
            <MapPin size={20} data-id="element-582" />
          </div>
          <div data-id="element-583">
            <h3 className="font-medium text-brand-dark" data-id="element-584">Market Status</h3>
            <p className="text-sm text-brand-muted mt-0.5" data-id="element-585">
              We will match sellers and buyers to you.
            </p>
          </div>
        </div>
        <a href="#" className="text-sm text-brand-forest font-medium hover:underline whitespace-nowrap" data-id="element-586">
          Learn details and help activate your market →
        </a>
      </div>

      {/* Share Modal */}
      {showShareModal && <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-587">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl relative animate-in fade-in zoom-in-95 duration-200" data-id="element-588">
            <button onClick={() => setShowShareModal(false)} className="absolute top-4 right-4 p-2 text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite rounded-full transition-colors" data-id="element-589">
              <X size={20} data-id="element-590" />
            </button>

            <h2 className="font-serif font-semibold text-xl text-brand-dark mb-6" data-id="element-591">
              Share your profile
            </h2>

            {/* Copy Link */}
            <div className="mb-6" data-id="element-592">
              <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-593">
                Copy Link
              </label>
              <div className="flex items-center gap-2" data-id="element-594">
                <div className="flex-1 bg-brand-offwhite border border-brand-light rounded-xl px-4 py-3 font-mono text-sm text-brand-dark truncate" data-id="element-595">
                  {fullUrl}
                </div>
                <button onClick={handleCopy} className="shrink-0 flex items-center gap-2 bg-brand-forest text-white px-4 py-3 rounded-xl font-medium hover:bg-brand-forestHover transition-colors" data-id="element-596">
                  {copied ? <Check size={18} data-id="element-597" /> : <Copy size={18} data-id="element-598" />}
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
            </div>

            {/* QR Code */}
            <div className="mb-6 border-t border-brand-light pt-6" data-id="element-599">
              <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-4 text-center" data-id="element-600">
                Scan to visit profile
              </label>
              <div className="flex flex-col items-center" data-id="element-601">
                <div className="w-32 h-32 bg-white border-2 border-brand-light rounded-xl p-2 mb-4" data-id="element-602">
                  {/* Placeholder QR Code SVG */}
                  <svg viewBox="0 0 100 100" className="w-full h-full text-brand-dark" data-id="element-603">
                    <rect width="100" height="100" fill="none" data-id="element-604" />
                    <path d="M10,10 h20 v20 h-20 z M15,15 h10 v10 h-10 z" fill="currentColor" data-id="element-605" />
                    <path d="M70,10 h20 v20 h-20 z M75,15 h10 v10 h-10 z" fill="currentColor" data-id="element-606" />
                    <path d="M10,70 h20 v20 h-20 z M15,75 h10 v10 h-10 z" fill="currentColor" data-id="element-607" />
                    <rect x="40" y="10" width="10" height="10" fill="currentColor" data-id="element-608" />
                    <rect x="55" y="20" width="10" height="10" fill="currentColor" data-id="element-609" />
                    <rect x="10" y="40" width="10" height="10" fill="currentColor" data-id="element-610" />
                    <rect x="25" y="55" width="10" height="10" fill="currentColor" data-id="element-611" />
                    <rect x="40" y="40" width="20" height="20" fill="currentColor" data-id="element-612" />
                    <rect x="70" y="40" width="10" height="10" fill="currentColor" data-id="element-613" />
                    <rect x="85" y="55" width="10" height="10" fill="currentColor" data-id="element-614" />
                    <rect x="40" y="70" width="10" height="10" fill="currentColor" data-id="element-615" />
                    <rect x="55" y="85" width="10" height="10" fill="currentColor" data-id="element-616" />
                    <rect x="70" y="70" width="20" height="20" fill="currentColor" data-id="element-617" />
                  </svg>
                </div>
                <button className="text-sm font-medium text-brand-forest hover:text-brand-dark transition-colors" data-id="element-618">
                  Download QR
                </button>
              </div>
            </div>

            {/* Social Share */}
            <div className="border-t border-brand-light pt-6" data-id="element-619">
              <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-4" data-id="element-620">
                Share via
              </label>
              <div className="flex justify-between gap-2" data-id="element-621">
                <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl + '?utm_source=twitter&utm_medium=social&utm_campaign=agent_share')}`} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-2 group" data-id="element-622">
                  <div className="w-12 h-12 rounded-full bg-brand-offwhite border border-brand-light flex items-center justify-center group-hover:bg-brand-sage group-hover:border-brand-forest/30 transition-all" data-id="element-623">
                    <Twitter size={20} className="text-brand-dark" data-id="element-624" />
                  </div>
                  <span className="text-xs text-brand-muted group-hover:text-brand-dark" data-id="element-625">
                    X
                  </span>
                </a>

                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl + '?utm_source=facebook&utm_medium=social&utm_campaign=agent_share')}`} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-2 group" data-id="element-626">
                  <div className="w-12 h-12 rounded-full bg-brand-offwhite border border-brand-light flex items-center justify-center group-hover:bg-brand-sage group-hover:border-brand-forest/30 transition-all" data-id="element-627">
                    <Facebook size={20} className="text-brand-dark" data-id="element-628" />
                  </div>
                  <span className="text-xs text-brand-muted group-hover:text-brand-dark" data-id="element-629">
                    Facebook
                  </span>
                </a>

                <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(fullUrl + '?utm_source=linkedin&utm_medium=social&utm_campaign=agent_share')}`} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-2 group" data-id="element-630">
                  <div className="w-12 h-12 rounded-full bg-brand-offwhite border border-brand-light flex items-center justify-center group-hover:bg-brand-sage group-hover:border-brand-forest/30 transition-all" data-id="element-631">
                    <Linkedin size={20} className="text-brand-dark" data-id="element-632" />
                  </div>
                  <span className="text-xs text-brand-muted group-hover:text-brand-dark" data-id="element-633">
                    LinkedIn
                  </span>
                </a>

                <a href={`mailto:?subject=Check out my Eaves Pro profile&body=${encodeURIComponent('View my real estate performance, reviews, and active listings here: ' + fullUrl + '?utm_source=email&utm_medium=share&utm_campaign=agent_share')}`} className="flex flex-col items-center gap-2 group" data-id="element-634">
                  <div className="w-12 h-12 rounded-full bg-brand-offwhite border border-brand-light flex items-center justify-center group-hover:bg-brand-sage group-hover:border-brand-forest/30 transition-all" data-id="element-635">
                    <Mail size={20} className="text-brand-dark" data-id="element-636" />
                  </div>
                  <span className="text-xs text-brand-muted group-hover:text-brand-dark" data-id="element-637">
                    Email
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}